import { render } from "./stock-list.vue?vue&type=template&id=6054673a"
import script from "./stock-list.vue?vue&type=script&lang=js"
export * from "./stock-list.vue?vue&type=script&lang=js"

import "./stock-list.vue?vue&type=style&index=0&id=6054673a&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__